
import store from '@/store/index'
export const option = {
  height: 'auto',
  lazy: true,
  tip: false,
  simplePage: true,
  searchShow: true,
  searchMenuSpan: 6,
  tree: true,
  border: true,
  index: true,
  selection: false,
  viewBtn: false,
  editBtn: false,
  delBtn: false,
  addBtn: false,
  labelWidth: 150,
  searchLabelWidth: 100,
  menu: false,
  dialogClickModal: false,
  rowKey: 'index',
  column: [
    {
      label: '代理商简称',
      prop: 'deptId',
      type: 'select',
      filterable: true,
      multiple: true,
      display: false,
      search: true,
      searchMultiple: true,
      searchClearable: true,
      defaultExpandAll: true,
      searchOrder: 1000,
      hide: true,
      dicData: store.getters.companies,
      props: {
        label: 'title',
        value: 'id',
      },
      display: false,
      minWidth: 120
    },
    {
      label: '代理级别',
      prop: 'agentLevel',
      minWidth: 120,
      type: 'select',
      search: false,
      order: 10,
      hide: false,
      maxlength: 2,
      dicData: [
        {
          label: '省代',
          value: 0
        },
        {
          label: '市代',
          value: 1
        },
        {
          label: '一般代理',
          value: 2
        }
      ],
    },
    {
      label: '地区',
      display: false,
      prop: 'che300CityName',
      search: false,
      order: 11,
      minWidth: 120
    },
    {
      label: '代理商简称',
      prop: 'deptName',
      search: false,
      order: 999,
      maxlength: 50,
      minWidth: 120,
    },
    {
      label: '代理商全称',
      prop: 'fullName',
      search: false,
      order: 998,
      maxlength: 50,
      minWidth: 120,
    },
    {
      label: '放款总额',
      prop: 'totalLoanAmount',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      label: '存量本金',
      prop: 'principalMoney',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      label: '存量本息',
      prop: 'lendingAmountPer',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      label: '结清总额',
      prop: 'totalSettlementAmount',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      // 如果是操作了代理商接管的显示【直管】。如果只有乾来租车产品的代理商显示【直管】。如果是代管类型代理商显示【未代偿】/【持续代偿】
      // 持续代偿展示形式【三个月】+【持续代偿】，【十五个月】+【持续代偿】……拼成结果：十三个月持续代偿
      // 持续代偿：代理商的存量客户中没有逾期未代偿状态的客户，出现逾期未代偿状态客户，在逾期代偿财务确认处理后，开始 计算时长。
      // 未代偿：代理商的存量客户中当前有逾期未代偿状态的客户。
      // 后端已翻译
      label: '代偿状态',
      prop: 'compensatoryState',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50,
    },
    {
      // 如果是操作了代理商接管的显示【直管】。如果只有乾来租车产品的代理商显示【直管】。如果是代管类型代理商显示【持续进件】/【未进件】。
      // 根据代理商下业务员最后近一次新增进件时间与当前时间计算，得到未进件时长对应到未进件类型，若时长在30天以内都属于【持续进件】
      // 未进件类型：【30天以上未进件】/【60天以上未进件】/【90天以上未进件】
      // 后端已翻译
      label: '业务状态',
      prop: 'bussStatus',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50,
    },
    {
      // 停止进件/停止返佣/正常合作，无停止进件和停止返佣状态则展示正常合作，既有停止进件和停止返佣展示停止进件
      // 后端已翻译
      label: '管控状态',
      prop: 'controlStatus',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50,
    },
    {
      label: '代理状态',
      prop: 'stopAgent',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50,
      dicData: [
        {
          label: '终止代理',
          value: '2'
        },
        {
          label: '正常代理',
          value: '1'
        }
      ]
    },
    {
      label: '代理商评级',
      prop: 'agentRankDesc',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50,
    },
    {
      label: '保证金金额',
      prop: 'securityMoney',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      label: '保证金余额',
      prop: 'securityMoneyBalance',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    },
    {
      label: '保证金占用额',
      prop: 'securityMoneyStockOccupy',
      search: false,
      order: 998,
      minWidth: 120,
      maxlength: 50
    }
  ],
}